import React from 'react';
import { getCustomerId } from '../../helpers/AbloyKeyHelper';

class Activation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkingStatus    : false
    }
  }

  /* for both cases when successfully activated key or removed access (and page wasn't refreshed) */
  renderSuccess(handedoutToCurrent) {
    let status = "Avain on onnistuneesti tyhjennetty Abloyn tietokannasta."
    if (handedoutToCurrent) {
      status = "Avain on onnistuneesti aktivoitu Abloyn tietokantaan."
    }

    return (
      <div className={"activation-container"}>
        <div className={"activate-success"}>
          <i className="fa fa-regular fa-square-check" aria-hidden="true" />
          <p>{status}</p>
        </div>
        <button className="btn min-width" onClick={() => this.setState({checkingStatus: false})}>Ok</button>
      </div>
    )
  }

  /* for both cases when activating key and removing access (programmed = false) */
  renderUpdate(leaseId, item, abloyKey) {
    return (
      <div className={"activation-container"}>
        <div className={"activate-success"}>
          <i className="fa fa-regular fa-square-check" aria-hidden="true" />
          <p>Avain on ohjelmoitu Abloy järjestelmään, syötä se nyt ohjelmointipäätteeseen.</p>
        </div>
        <button
          className="btn min-width"
          style={{width: '200px'}}
          disabled={(this.props.updating ? " disabled" : null)}
          onClick={() => { this.setState({checkingStatus: true}); this.props.getKeyUpdates(leaseId, item.id, abloyKey); }}
        >
          {this.props.updating ? "Odota hetki…" : "Päivitä avaimen tilanne"}
        </button>
      </div>
    )
  }

  /* handedoutToCurrent = true && programmed = true */
  renderRemoveAccess(leaseId, customerId, item, abloyKey) {
    return (
      <div className="card-keys-access card-keys-row">
        <button
          className={"btn btn-danger hover-btn min-width"}
          disabled={(this.props.updating ? " disabled" : null)}
          onClick={() => (confirm("Oletko varma, että haluat poistaa avaimen? " + item.stamp) ? this.props.removeAccessAK(leaseId, customerId, item.id, abloyKey) : void(0))}
        >
          {this.props.updating ? "Odota hetki…" : "Poista oikeudet"}
        </button>
        <button
          className={"btn btn-danger hover-btn"}
          disabled={(this.props.updating ? " disabled" : null)}
          onClick={() => (confirm("Haluatko varmasti merkata avaimen kadonneeksi? " + item.stamp) ? this.props.markLostAK(leaseId, customerId, item.id, abloyKey) : void(0))}
        >
          <i className="fa fa-question-circle" aria-hidden="true" />
          <span className={"tooltiptext"}>Merkkaa hävinneeksi</span>
        </button>
        <button
          className={"btn btn-danger hover-btn"}
          disabled={(this.props.updating ? "disabled" : null)}
          onClick={() => (confirm("Oletko varma, että haluat merkitä avaimen hajonneeksi? Hajonneeksi merkittyä avainta ei vähennetä asukkaan vakuudesta! " + item.stamp) ? this.props.markBrokenAK(leaseId, customerId, item.id, abloyKey): void(0))}
        >
          <i className="fa fa-trash-can" aria-hidden="true" />
          <span className={"tooltiptext"}>Merkitse avain hajonneeksi</span>
        </button>
      </div>
    )
  }

  render() {
    const leaseId = this.props.lease.id;
    const item    = this.props.item;
    const apartmentKeyId     = item.id;
    const handedoutToCurrent = this.props.handedoutToCurrent;
    const abloyKey           = this.props.abloyKey;
    const customerId         = getCustomerId(abloyKey, this.props.lease);
    const renderUpdateMessage = _.find(this.props.abloyUpdatingMessageStatus, (status) => status === abloyKey.where_at)

    if (!abloyKey || !abloyKey.identity) {
      return (null)
    }

    if (this.state.checkingStatus && abloyKey.programmed && !abloyKey.is_busy) {
      return this.renderSuccess(handedoutToCurrent)
    }

    if (renderUpdateMessage && !abloyKey.programmed && !abloyKey.is_busy) {
      return this.renderUpdate(leaseId, item, abloyKey)
    }

    const removeOrLostEnabled = _.find(this.props.abloyKeyOperations, (op) => op == 'remove_or_lost')

    if (handedoutToCurrent && removeOrLostEnabled) {
      return this.renderRemoveAccess(leaseId, customerId, item, abloyKey);
    }

    return (null)
  }
}

export default Activation
